import useGetMeOperation from '../graphql/operations/queries/useGetMeOperation';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getJwtToken } from '../graphql/client/makeApolloClient';
import isNil from 'lodash/isNil';

export enum UserType {
  USER = 'USER',
  LEAD_USER = 'LEAD_USER',
  TEMP_USER = 'TEMP_USER',
}

export const useDetectUser = () => {
  const { me, loading } = useGetMeOperation();

  const [token, setToken] = useState<string | undefined>();

  const getToken = useCallback(async () => {
    const res = await getJwtToken();
    setToken(res ?? '');
  }, []);

  useEffect(() => {
    getToken().then();
  }, [getToken]);
  return {
    userType: useMemo((): UserType | null => {
      if (loading) {
        return null;
      }
      if (me?.id) {
        return UserType.USER;
      }
      if (isNil(token)) {
        return null;
      }
      if (!token) {
        return UserType.LEAD_USER;
      }
      return UserType.TEMP_USER;
    }, [loading, me?.id, token]),
  };
};
